<ui-dialog
    size="small"
    primaryButtonLabel="{{ 'delete' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    [header]="'applicant-tracker.deleteFunnelTemplate' | translate"
    [open]="isTemplateDeleteModalOpen"
    deleteDialog
    (closing)="closeFunnelTemplateDeleteModal()"
    (primaryButtonPressed)="onDeleteFunnelTemplate()"
    (secondaryButtonPressed)="closeFunnelTemplateDeleteModal()"
>
    <p>
        {{
            'applicant-tracker.areYouSureYouWantToDeleteFunnelTemplateName'
                | translate: { funnelTemplateName: funnelTemplate?.name }
        }}
    </p>
</ui-dialog>

<div class="page-container">
    <app-header title="applicant-tracker.funnelTemplates" [menuService]="recruitingModuleMenuService">
        <div class="buttons">
            <ui-button [routerLink]="'./create'" type="primary"
                ><mat-icon svgIcon="plus"></mat-icon>
                {{ 'applicant-tracker.createFunnelTemplate' | translate }}</ui-button
            >
        </div>
    </app-header>
    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            *ngIf="table"
            [table]="table"
            (menuItemSelected)="menuAction($event)"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <app-empty-state
                label="applicant-tracker.noFunnelTemplatesFound"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
        </app-table>
    </ui-card>
</div>
